import { render, staticRenderFns } from "./StudentEditTabAddresses.vue?vue&type=template&id=310e0736&scoped=true&"
import script from "./StudentEditTabAddresses.vue?vue&type=script&lang=js&"
export * from "./StudentEditTabAddresses.vue?vue&type=script&lang=js&"
import style0 from "./StudentEditTabAddresses.vue?vue&type=style&index=0&id=310e0736&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310e0736",
  null
  
)

export default component.exports